const header_icons = {
	left_arrow: (options) => (
		<svg
			width={(options && options.width) || "9"}
			height={(options && options.height) || "14"}
			viewBox="0 0 9 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M0.223292 6.45372L6.45347 0.223657C6.59757 0.0794465 6.78992 0 6.99503 0C7.20013 0 7.39249 0.0794465 7.53658 0.223657L7.99539 0.682352C8.29394 0.981244 8.29394 1.46703 7.99539 1.76547L2.76376 6.9971L8.0012 12.2345C8.14529 12.3787 8.22485 12.571 8.22485 12.776C8.22485 12.9812 8.14529 13.1734 8.0012 13.3178L7.54239 13.7763C7.39818 13.9206 7.20593 14 7.00083 14C6.79573 14 6.60337 13.9206 6.45927 13.7763L0.223292 7.54059C0.0788536 7.39592 -0.000478745 7.20277 -2.28882e-05 6.99744C-0.000478745 6.79131 0.0788536 6.59827 0.223292 6.45372Z"
				fill={(options && options.color) || "#C2C2C2"}
			/>
		</svg>
	),

	right_arrow: (options) => (
		<svg
			width={(options && options.width) || "10"}
			height={(options && options.height) || "14"}
			viewBox="0 0 10 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.99985 6.45372L2.76968 0.223657C2.62558 0.0794465 2.43322 0 2.22812 0C2.02301 0 1.83066 0.0794465 1.68656 0.223657L1.22775 0.682352C0.929202 0.981244 0.929202 1.46703 1.22775 1.76547L6.45939 6.9971L1.22195 12.2345C1.07785 12.3787 0.998291 12.571 0.998291 12.776C0.998291 12.9812 1.07785 13.1734 1.22195 13.3178L1.68076 13.7763C1.82497 13.9206 2.01721 14 2.22231 14C2.42742 14 2.61977 13.9206 2.76387 13.7763L8.99985 7.54059C9.14429 7.39592 9.22362 7.20277 9.22317 6.99744C9.22362 6.79131 9.14429 6.59827 8.99985 6.45372Z"
				fill={(options && options.color) || "#666666"}
			/>
		</svg>
	),

	board_icon: (options) => (
		<svg
			width={(options && options.width) || "22"}
			height={(options && options.height) || "22"}
			viewBox="0 0 22 22"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1.0158 15.6676C1.08994 15.7417 1.1905 15.7834 1.29536 15.7834H7.90956L5.89222 19.793C5.78473 20.0066 5.76651 20.2542 5.84157 20.4813C5.91664 20.7084 6.07883 20.8963 6.29246 21.0038C6.5061 21.1113 6.75369 21.1295 6.98076 21.0544C7.20783 20.9794 7.39578 20.8172 7.50327 20.6035L9.9287 15.7834H12.0711L14.4967 20.6039L14.4967 20.6039C14.55 20.7097 14.6236 20.8039 14.7132 20.8812C14.8029 20.9586 14.907 21.0175 15.0194 21.0546C15.1319 21.0917 15.2505 21.1063 15.3686 21.0975C15.4867 21.0888 15.6019 21.0569 15.7077 21.0036C15.8134 20.9503 15.9077 20.8768 15.985 20.7871C16.0623 20.6974 16.1212 20.5933 16.1583 20.4809C16.1954 20.3684 16.21 20.2498 16.2013 20.1317C16.1926 20.0136 16.1607 19.8984 16.1074 19.7927C16.1074 19.7926 16.1074 19.7926 16.1074 19.7926L14.0902 15.7834H20.7044C20.8093 15.7834 20.9098 15.7417 20.984 15.6676C21.0581 15.5934 21.0998 15.4929 21.0998 15.388V13.8691C21.0998 13.7642 21.0581 13.6636 20.984 13.5895C20.9098 13.5154 20.8093 13.4737 20.7044 13.4737H20.2357V2.56116C20.2357 2.45631 20.194 2.35575 20.1199 2.28161L20.0491 2.35232L20.1199 2.2816C20.0457 2.20746 19.9452 2.16581 19.8403 2.16581H11.9016V1.29536C11.9016 1.1905 11.8599 1.08994 11.7858 1.0158L11.7858 1.0158C11.7116 0.941654 11.6111 0.9 11.5062 0.9H10.4936C10.3887 0.9 10.2881 0.941653 10.214 1.0158L10.214 1.0158M1.0158 15.6676L1.08638 15.597L1.0158 15.6676ZM1.0158 15.6676L1.0158 15.6676C0.941654 15.5934 0.9 15.4929 0.9 15.388V13.8691C0.9 13.7642 0.941653 13.6636 1.0158 13.5895L1.0158 13.5895C1.08994 13.5154 1.1905 13.4737 1.29536 13.4737H1.76413V2.56116C1.76413 2.45631 1.80578 2.35575 1.87992 2.28161C1.95407 2.20746 2.05463 2.16581 2.15948 2.16581H10.0982V1.29536C10.0982 1.1905 10.1399 1.08994 10.214 1.0158M10.214 1.0158L10.2846 1.08638L10.214 1.0158ZM6.59878 20.1481L6.59881 20.148L8.79471 15.7834H9.04339L6.79704 20.248C6.79048 20.261 6.78142 20.2726 6.77038 20.2821C6.75934 20.2916 6.74653 20.2989 6.73269 20.3034C6.71885 20.308 6.70424 20.3098 6.68971 20.3087C6.67517 20.3076 6.66099 20.3037 6.64797 20.2971C6.63495 20.2906 6.62335 20.2815 6.61384 20.2705C6.60432 20.2594 6.59707 20.2466 6.5925 20.2328C6.58793 20.219 6.58614 20.2043 6.58721 20.1898C6.58829 20.1753 6.59222 20.1611 6.59878 20.1481ZM15.4013 20.1484L15.4013 20.1484C15.4099 20.1653 15.4139 20.1841 15.4131 20.203C15.4123 20.222 15.4066 20.2404 15.3967 20.2565C15.3867 20.2726 15.3728 20.2859 15.3563 20.2951C15.3397 20.3043 15.3211 20.3091 15.3022 20.3091C15.2816 20.3089 15.2615 20.3031 15.2439 20.2923C15.2264 20.2816 15.2122 20.2662 15.2028 20.2479C15.2027 20.2478 15.2027 20.2477 15.2027 20.2476L12.9562 15.7834H13.2049L15.4013 20.1484ZM10.8889 1.69071H11.1109V2.16581H10.8889V1.69071ZM2.55484 2.95652H19.4449V13.4737H2.55484V2.95652ZM20.3091 14.9927H1.69071V14.2644H20.3091V14.9927Z"
				fill="#666666"
				stroke="#868686"
				strokeWidth="0.2"
			/>
		</svg>
	),

	shareIcon: (options) => (
		<svg
			width="25"
			height="11.764"
			viewBox="0 0 25 11.764"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M2.236 5.882C2.236 3.871 3.871 2.236 5.882 2.236H10.588V0H5.882C2.636 0 0 2.635 0 5.882C0 9.129 2.636 11.764 5.882 11.764H10.588V9.529H5.882C3.871 9.529 2.236 7.894 2.236 5.882Z"
				fill={options.color ? options.color : "white"}
			/>
			<path
				d="M16.472 4.706H7.061V7.059H16.472V4.706Z"
				fill={options.color ? options.color : "white"}
			/>
			<path
				d="M17.649 0H12.943V2.236H17.649C19.661 2.236 21.296 3.871 21.296 5.882C21.296 7.894 19.661 9.529 17.649 9.529H12.943V11.764H17.649C20.896 11.764 23.531 9.129 23.531 5.882C23.531 2.635 20.896 0 17.649 0Z"
				fill={options.color ? options.color : "white"}
			/>
		</svg>
	),

	shareScreen: (options) => (
		<svg
			width={(options && options.width) || "24"}
			height={(options && options.height) || "20"}
			viewBox="0 0 24 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect x="0.5" y="0.5" width="23" height="19" rx="1.5" stroke="#666666" />
			<path
				d="M12 6V14.4853"
				stroke="#666666"
				strokeWidth="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M15.5355 9.53553L12 6L8.46447 9.53553"
				stroke="#666666"
				strokeWidth="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	),
};

export default header_icons;
